<template>
  <div>
    <modal-crear-editar
      :configuracion="configuracion_modal"
      @realizado="restablecer_inputs"
    ></modal-crear-editar>
    <tablita
      :cols="columnas"
      @cargar="cargar($event)"
      @cargar_url="cargar_url($event)"
      @nuevo="crear"
      @editar="editar($event)"
      :configuracion="configuracion_tabla"
      @refresh="refrescar($event)"
    ></tablita>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import ModalCrearEditar from "../../components/Modal/ModalEditarCrear";
import Tabla from "../../components/Tabla/Tabla";
//import lenguaje from '../../config/es_datatable.json'
export default {
  data: () => ({
    filter: "",
    columnas: [
      {
        key: "id",
        label: "ID",
        busqueda: "",
        tipo: "number",
        searchable: true,
        path: "id",
      },
      {
        key: "rut",
        label: "Rut",
        busqueda: "",
        tipo: "string",
        searchable: true,
        path: "rut_completo",
      },
      //{key:'nombre',label:'Nombre',busqueda:'',tipo:'string',searchable:true,path:'nombre'},
      {
        key: "nombre",
        label: "Nombre",
        busqueda: "",
        tipo: "string_badge",
        searchable: true,
        path: "nombre",
        color_badge: "color_badge",
        path_badge: "texto_badge",
        mostrar_badge: "mostrar_badge",
      },
      {
        key: "codigo_siep",
        label: "Codigo SIEP",
        busqueda: "",
        tipo: "string",
        searchable: true,
        path: "codigo_siep",
      },
      {
        key: "agrupada_en",
        label: "Empresa Padre",
        busqueda: "",
        tipo: "string",
        searchable: false,
        path: "empresa_padre_texto",
      },
      {
        key: "tipo_empresa_ids",
        label: "Tipo Empresa",
        busqueda: [],
        tipo: "multiselect",
        searchable: true,
        path: "tipo_empresa_ids_texto",
        opciones: [],
        valor_opcion: "id",
        label_opcion: "nombre",
      },

      /* {key:'usuario_crea',label:'Representante',busqueda:'',tipo:'foreign_key',searchable:false,path:'user.name'}, */
      //{key:'tipo_empresa',label:'Tipo Empresa',busqueda:'',tipo:'select',searchable:true,path:'tipo_empresa',opciones:[{label:'Proveedor',valor:'es_proveedor'},{label:'Transporte',valor:'es_transportista'},{label:'Transbordador',valor:'es_transbordador'},{label:'Principal',valor:'es_principal'}],valor_opcion:'valor',label_opcion:'label'}
    ],
    botones: [
      {
        label: "Editar",
        clase: "btn-warning",
        evento: "editar",
        icono: "fa fa-pen",
      },
    ],
    lista: [],
    links: [],
    inputs: [
      {
        cols: 4,
        tipo: "texto",
        key: "rut",
        valor: "",
        label: "RUT (*)",
        disabled: true,
      },
      {
        cols: 4,
        tipo: "texto",
        key: "dv",
        valor: "",
        label: "DV (*)",
        disabled: true,
      },
      {
        cols: 4,
        tipo: "texto",
        key: "nombre",
        valor: "",
        label: "Nombre (*)",
        disabled: true,
      },
      {
        cols: 4,
        tipo: "texto",
        key: "codigo_siep",
        valor: "",
        label: "Codigo SIEP",
        disabled: false,
      },
      {
        cols: 4,
        tipo: "v-select_multiple",
        key: "tipo_empresa_ids",
        valor: "",
        label: "Tipo Empresa (*)",
        opciones: [],
        label_opcion: "nombre",
      },
      //{cols:4,tipo:'multiselect',key:'tipo_empresa_ids',valor:[],label:'Tipo Empresa (*)',opciones:[],valor_opcion:'id',label_opcion:'nombre',disabled:false},
      //{cols:4,tipo:'select',key:'tipo_empresa',valor:'',label:'Tipo Empresa (*)',opciones:[{label:'Proveedor',valor:'es_proveedor'},{label:'Transporte',valor:'es_transportista'},{label:'Transbordador',valor:'es_transbordador'},{label:'Principal',valor:'es_principal'}],valor_opcion:'valor',label_opcion:'label'},
      {
        cols: 4,
        tipo: "select-loadable",
        key: "agrupada_en",
        valor: "",
        label: "Empresa Padre",
        busqueda: "",
        ruta: "/empresas",
        parametro: "nombre",
        disabled: false,
        opciones: [],
        valor_opcion: "id",
        label_opcion: "nombre",
      },
      {
        cols: 4,
        tipo: "texto",
        key: "direccion",
        valor: "",
        label: "Dirección",
        disabled: false,
      },
      {
        cols: 4,
        tipo: "texto",
        key: "telefono",
        valor: "",
        label: "Telefono",
        disabled: false,
      },
      {
        cols: 4,
        tipo: "texto",
        key: "email",
        valor: "",
        label: "Email",
        disabled: false,
      },
      {
        cols: 4,
        tipo: "texto",
        key: "contacto",
        valor: "",
        label: "Contacto",
        disabled: false,
      },
      {
        cols: 4,
        tipo: "texto",
        key: "codigo",
        valor: "",
        label: "Codigo",
        disabled: false,
      },
      {
        cols: 4,
        tipo: "checkbox",
        key: "activo",
        valor: "",
        label: "Activo",
        disabled: false,
      },
    ],
    configuracion_modal: {
      titulo: "Registrar Empresa",
      ancho: "xl",
      ruta: "/empresas",
      tipo_ruta: "post",
      titulo_boton: "Crear",
      clase_boton: "btn-success",
    },
    configuracion_tabla: {
      titulo: "Listado de Empresas",
      titulo_boton: "Crear Empresa",
      clase_boton: "btn-primary",
      btn_nuevo: true,
    },
    pagina_actual: "",
    /* columns: [
            {label: 'Rut', field: 'rut'},
            {label: 'Nombre', field: 'nombre', headerClass: 'class-in-header second-class'}
        ], */
  }),
  mounted() {
    this.inicializar_tabla({
      columnas: [],
      lista: [],
      links: [],
      botones: [],
      botones_restringidos: [],
    });
    let storage = localStorage.getItem(this.path);
    if (storage) {
      storage = JSON.parse(storage);
      this.columnas.forEach((col) => {
        col.busqueda = storage.columnas.find((c) => c.key == col.key).val;
      });
    }
    this.$emit("spinner", true);
    this.cargar_tipos_empresas();
  },
  methods: {
    refrescar() {
      localStorage.removeItem(this.path);
      this.columnas.forEach((c) => {
        if (
          [
            "string",
            "number",
            "select",
            "select-loadable",
            "select-loadable-dependiente",
            "datetime",
            "html",
            "html_select",
          ].includes(c.tipo)
        ) {
          c.busqueda = "";
        }

        if (["multiselect"].includes(c.tipo)) {
          c.busqueda = [];
        }
      });
      this.$emit("cargar");
    },
    async cargar_tipos_empresas() {
      await this.axios
        .get(`${this.api}/tipos_empresas`, this.cabeceras_json)
        .then((res) => {
          ////console.log('tipos',res.data.data);
          this.$set(this.columnas[5], "opciones", res.data.data);
          this.$set(this.inputs[4], "opciones", res.data.data);
          //this.cargar("");
        })
        .catch((e) => {
          //alert(e);
        });
      this.$emit("cargar");
    },
    async cargar($event) {
      this.$emit("spinner", true);
      this.pagina_actual = `${this.api}/empresas${$event}`;
      this.lista = [];
      await this.axios
        .get(`${this.api}/empresas${$event}`, this.cabeceras_json)
        .then((res) => {
          this.lista = res.data.data.data;
          this.links = res.data.data.links;
          /* let config = {
                  columnas:this.columnas,
                  lista:this.lista,
                  links:this.links
                } */
          this.inicializar_tabla({
            columnas: this.columnas,
            lista: this.lista,
            links: this.links,
            botones: this.botones,
          });
          this.$emit("generar", this.columnas, this.lista);
          ////console.log('listado',res.data.data.data);
          //$('#empresas').DataTable().draw();
        })
        .catch((e) => {
          //alert(e);
        });
      this.$emit("spinner", false);
    },
    async cargar_url(url) {
      if (url) {
        this.$emit("spinner", true);
        this.pagina_actual = url;
        await this.axios
          .get(url, this.cabeceras_json)
          .then((res) => {
            this.lista = res.data.data.data;
            this.links = res.data.data.links;
            ////console.log('listado',res.data.data.data);
            this.setear_lista({ lista: this.lista, links: this.links });
            //$('#empresas').DataTable().draw();
          })
          .catch((e) => {
            //alert(e);
          });
        this.$emit("spinner", false);
      }
    },
    crear() {
      this.setear_inputs(this.inputs);
      this.inputs[0].disabled = false;
      this.inputs[1].disabled = false;
      this.inputs[2].disabled = false;

      this.configuracion_modal.ruta = `/empresas`;
      this.configuracion_modal.tipo_ruta = "post";
      this.configuracion_modal.titulo_boton = "Crear";
      this.configuracion_modal.clase_boton = "btn-success";

      this.$emit("abrir", { inputs: this.inputs });
    },
    devuelve_valor(item, path) {
      let keys = path.split(".");
      let valor = item;
      keys.forEach((k) => {
        for (var key in valor) {
          if (key == k) {
            valor = valor[key];
          }
        }
      });
      return valor;
    },
    editar(evento) {
      //console.log('evento',evento);
      let item = evento.item;
      this.inputs.forEach((i) => {
        //recorrido del objeto a editar
        Object.keys(item).forEach((key) => {
          let valor = item[key];
          if (i.key == key) {
            i.valor = valor;
          }
        });

        /* if(i.key == 'tipo_empresa'){
                if(item.es_proveedor == 1){
                  i.valor = 'es_proveedor';
                }
                if(item.es_transbordador == 1){
                  i.valor = 'es_transbordador';
                }
                if(item.es_transportista == 1){
                  i.valor = 'es_transportista';
                }
              } */
      });
      this.setear_inputs(this.inputs);
      this.configuracion_modal.ruta = `/empresas/${evento.item.id}`;
      this.configuracion_modal.tipo_ruta = "put";
      this.configuracion_modal.titulo_boton = "Actualizar";
      this.configuracion_modal.clase_boton = "btn-warning";

      this.$emit("abrir");
    },
    restablecer_inputs() {
      this.cargar_url(this.pagina_actual);
      this.inputs.forEach((i) => {
        if (i.tipo == "multiselect") {
          i.valor = [];
        } else {
          i.valor = "";
        }
      });
      this.setear_inputs(this.inputs);
    },
    ...mapActions(["inicializar_tabla", "setear_lista", "setear_inputs"]),
  },
  components: {
    "modal-crear-editar": ModalCrearEditar,
    tablita: Tabla,
  },
  computed: {
    ...mapState(["api", "cabeceras_json"]),
    query() {
      let string = "?";
      let and = "";
      let total = this.columnas.length - 1;
      this.columnas.forEach((c, index) => {
        if (index > 0 && string.length > 0) {
          and = "&";
        } else if (index == total) {
          and = "";
        }

        if (c.busqueda != "") {
          if (c.key == "tipo_empresa") {
            string += `${and}${c.busqueda}=1`;
          } else {
            string += `${and}${c.key}=${c.busqueda}`;
          }
        }
      });
      return string;
    },

    path() {
      return this.$router.currentRoute.path;
    },
  },
};
</script>
<style>
.form-control {
  height: calc(1em + 1.25rem + 5px);
}
</style>